import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import React, { useContext, useState } from "react"
import { client } from "../.."
import { deleteQBP } from "../../api/api"
import { showErrorMessage } from "../../helper/helper"
import { CompanyContext } from "./CompanyDetail"
import { t } from "i18next"
import { Organisation } from "../../models/organisation/OrganisationModelV2"

type Props = {
    org: Organisation
}

export function ButtonDeleteQBP({ org }: Props) {

    const reload = useContext(CompanyContext)

    const [open, setOpen] = useState(false)

    function onDeleteQBP() {
        client.mutate({
            mutation: deleteQBP,
            variables: {
                id: org.id
            }
        }).then(() => {
            reload.reload()
        }).catch((e) => {
            showErrorMessage(e)
        })
    }

    const handleClose = () => {
        setOpen(false)
    }

    return <>
        <Button variant="contained" style={{ background: "red" }} onClick={(e) => { e.stopPropagation(); setOpen(true) }}>
            {t('delete')}
        </Button>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t('delete_all_title_qbp')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('delete_all_level_message')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('cancel')}</Button>
                <Button onClick={onDeleteQBP} autoFocus>{t('ok')}</Button>
            </DialogActions>
        </Dialog>
    </>
}